import React from "react";
import { appendLeftZero } from "../assets/js/utils";

function VerticalRange({ min = 0, max = 1, step = 1, value, handleOnChange }) {
  return (
    <div className="vertical-range">
      <span className="vertical-range__label">{appendLeftZero(value)}</span>
      <input
        className="vertical-range__slider"
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        // onChange={handleOnChange}
        onInput={handleOnChange}
      />
      <span className="vertical-range__label">{appendLeftZero(max)}</span>
    </div>
  );
}

export default VerticalRange;
